import { DueDiligenceFunnel } from '@/components/dueDiligence-page';
import { Helmet as Head } from 'react-helmet';
import useRefresh from '../../hooks/use-refresh';

const DueDiligencePage = () => {
  useRefresh();
  return (
    <>
      <Head>
        <title>Due Diligence</title>
      </Head>
      <DueDiligenceFunnel />
    </>
  );
};

export default DueDiligencePage;
